// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let Sentry = require("../../reason/Sentry.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
let ReactErrorBoundary = require("react-error-boundary");
let RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
let UserViewPreferencesQuery_graphql = require("../../__generated__/UserViewPreferencesQuery_graphql.bs.js");
let UserViewPreferencesMutation_graphql = require("../../__generated__/UserViewPreferencesMutation_graphql.bs.js");

let convertVariables = UserViewPreferencesMutation_graphql.Internal.convertVariables;

let convertResponse = UserViewPreferencesMutation_graphql.Internal.convertResponse;

let convertWrapRawResponse = UserViewPreferencesMutation_graphql.Internal.convertWrapRawResponse;

let commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables, UserViewPreferencesMutation_graphql.node, convertResponse, convertWrapRawResponse);

let use = RescriptRelay_Mutation.useMutation(convertVariables, UserViewPreferencesMutation_graphql.node, convertResponse, convertWrapRawResponse);

let Mutation_defaultView_decode = UserViewPreferencesMutation_graphql.Utils.defaultView_decode;

let Mutation_defaultView_fromString = UserViewPreferencesMutation_graphql.Utils.defaultView_fromString;

let Mutation = {
  defaultView_decode: Mutation_defaultView_decode,
  defaultView_fromString: Mutation_defaultView_fromString,
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  commitMutation: commitMutation,
  use: use
};

let convertVariables$1 = UserViewPreferencesQuery_graphql.Internal.convertVariables;

let convertResponse$1 = UserViewPreferencesQuery_graphql.Internal.convertResponse;

let convertWrapRawResponse$1 = UserViewPreferencesQuery_graphql.Internal.convertWrapRawResponse;

let use$1 = RescriptRelay_Query.useQuery(convertVariables$1, UserViewPreferencesQuery_graphql.node, convertResponse$1);

let useLoader = RescriptRelay_Query.useLoader(convertVariables$1, UserViewPreferencesQuery_graphql.node, prim => prim);

let usePreloaded = RescriptRelay_Query.usePreloaded(UserViewPreferencesQuery_graphql.node, convertResponse$1, prim => prim);

let fetch = RescriptRelay_Query.fetch_(UserViewPreferencesQuery_graphql.node, convertResponse$1, convertVariables$1);

let fetchPromised = RescriptRelay_Query.fetchPromised(UserViewPreferencesQuery_graphql.node, convertResponse$1, convertVariables$1);

let retain = RescriptRelay_Query.retain(UserViewPreferencesQuery_graphql.node, convertVariables$1);

let Query_defaultView_decode = UserViewPreferencesQuery_graphql.Utils.defaultView_decode;

let Query_defaultView_fromString = UserViewPreferencesQuery_graphql.Utils.defaultView_fromString;

let Query = {
  defaultView_decode: Query_defaultView_decode,
  defaultView_fromString: Query_defaultView_fromString,
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables$1,
  convertResponse: convertResponse$1,
  convertWrapRawResponse: convertWrapRawResponse$1,
  use: use$1,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  fetch: fetch,
  fetchPromised: fetchPromised,
  retain: retain
};

function use$2() {
  return Stdlib_Option.getOrThrow(use$1(undefined, undefined, undefined, undefined).userViewPreferences, "Your property view preferences could not be loaded");
}

let defaults = {
  desktopDefaultView: "MAP",
  mobileDefaultView: "LIST"
};

let context = React.createContext(defaults);

let make = context.Provider;

let ContextProvider = {
  make: make
};

function UserViewPreferences$LoadedPreferences(props) {
  let preferences = use$1(undefined, undefined, undefined, undefined).userViewPreferences;
  let value = preferences !== undefined ? ({
      desktopDefaultView: preferences.desktopDefaultView,
      mobileDefaultView: preferences.mobileDefaultView
    }) : defaults;
  let value$1 = React.useMemo(() => value, [
    value.desktopDefaultView,
    value.mobileDefaultView
  ]);
  return JsxRuntime.jsx(make, {
    value: value$1,
    children: props.children
  });
}

let LoadedPreferences = {
  make: UserViewPreferences$LoadedPreferences
};

function UserViewPreferences$BrowsingProvider(props) {
  let children = props.children;
  return JsxRuntime.jsx(ReactErrorBoundary.ErrorBoundary, {
    FallbackComponent: _error => JsxRuntime.jsx(make, {
      value: defaults,
      children: children
    }),
    children: JsxRuntime.jsx(UserViewPreferences$LoadedPreferences, {
      children: children
    }),
    onError: error => Sentry.captureException(error, "UserViewPreferences.res", undefined, undefined, undefined)
  });
}

let BrowsingProvider = {
  make: UserViewPreferences$BrowsingProvider
};

function useForBrowsing() {
  return React.useContext(context);
}

exports.Mutation = Mutation;
exports.Query = Query;
exports.use = use$2;
exports.defaults = defaults;
exports.context = context;
exports.ContextProvider = ContextProvider;
exports.LoadedPreferences = LoadedPreferences;
exports.BrowsingProvider = BrowsingProvider;
exports.useForBrowsing = useForBrowsing;
/* commitMutation Not a pure module */
